// extracted by mini-css-extract-plugin
export default {"container":"styles_container__cUQJQ","image_slide":"styles_image_slide__hzxRv","image_fit":"styles_image_fit__OJ6mj"};